/**
 * @changelog
 *
 * 2026-03-17 (0.1.0) (jhoward)
 *   - Add new src\helpers\isOfferRedeemed.ts to determine if an offer is redeemed.
 */

import type { OpcOffer } from '@/defs/api/OpcOffer';

export default function isOfferRedeemed(offer: OpcOffer): boolean {
  return ['RESERVED', 'CHECKED-IN', 'REDEEMED'].includes(offer.OFFER_ACCEPT_STATUS);
}
